export const API_LEAD_SUMMARY_CONV_UNCONV_SUCCESS =
  "API_LEAD_SUMMARY_CONV_UNCONV_SUCCESS";
export const API_LEAD_SUMMARY_CONV_UNCONV_FAIL =
  "API_LEAD_SUMMARY_CONV_UNCONV_FAIL";
export const GET_LEAD_SUMMARY_CONV_UNCONV = "GET_LEAD_SUMMARY_CONV_UNCONV";
